import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { LensSectionMode, LensSide } from "src/app/model/configuration/configuration";
import { ArticleType, OrderItem } from "src/app/model/order/order";
import { NewOrderStoreService } from "src/app/new-order/new-order-store-service.service";
import { CartService } from "./cart.service";
import {LensConfigMode} from "../../model/configuration/configuration";

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss']
})
export class CartComponent {

    cartItems: OrderItem[];

    lensesItems: OrderItem[] = [];
    careItems: OrderItem[] = [];
    accessoriesItems: OrderItem[] = [];

    constructor(private cartService: CartService, private translateService: TranslateService,
                private newOrderStoreService: NewOrderStoreService, private router: Router) {}

    ngOnInit(): void {
        this.cartService.fetchCartItems();

        this.cartService.getCartItems().subscribe(data => {
            this.cartItems = data;
            this.careItems = this.cartItems.filter(item => item.article.type === ArticleType.CARE);
            this.accessoriesItems = this.cartItems.filter(item => item.article.type === ArticleType.ACCESSORY);
            this.lensesItems = this.cartItems.filter(item => item.article.type === ArticleType.LENS);
        });

        this.cartService.cartItems$.subscribe(data => {
            this.cartItems = data;
            this.careItems = this.cartItems.filter(item => item.article.type === ArticleType.CARE);
            this.accessoriesItems = this.cartItems.filter(item => item.article.type === ArticleType.ACCESSORY);
            this.lensesItems = this.cartItems.filter(item => item.article.type === ArticleType.LENS);
        });
    }

    deleteAll(event: any) {
        event.stopPropagation();
        this.cartService.getCartItems().subscribe(orderItems => {
            let ids: number[] = [];
            ids = orderItems.filter(orderItem => orderItem.isNew !== true).map(orderItem => orderItem.orderItemId);
            if(ids && ids.length > 0) {
                this.cartService.deleteCartItems(ids);
            }
            this.cartService.clearCart();
        })
    }

    confirmOrder(event: any) {
        event.stopPropagation();
        let fragment = 'order-confirm';
        this.newOrderStoreService.setLensConfigMode(LensConfigMode.DUAL);
        this.newOrderStoreService.setLensSectionMode(LensSectionMode.ORDER_CONFIRM);
        this.newOrderStoreService.setIsLeftSideEnable(true);
        this.newOrderStoreService.setIsRightSideEnable(true);
        this.router.navigate(['/new-order'], {fragment: fragment});
        setTimeout(()=>{
            document.getElementById(fragment).scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest"
            });
            this.newOrderStoreService.changeLensSectionMode(LensSectionMode.ORDER_CONFIRM);
        }, 50);
    }

    deleteItem(event: any, item: OrderItem) {
        event.stopPropagation();
        this.cartService.deleteCartItem(item);
    }

    translateReturnValue(val: boolean): Observable<string> {
        return this.translateService.get(val ? "newOrder.cart.returnValues.true" : "newOrder.cart.returnValues.false");
    }

    translateSide(side: LensSide): Observable<string> {
        return this.translateService.get("common.lensSides." + side.toLowerCase());
    }
}
